import React from 'react';
import DashboardCard from './DashboardCard';
import { RegistryDataItem } from '../../config/registryData';
import { useModalState } from '../../hooks/useModalState';
import RegistryDashModal from './RegistryDashModal';

interface RegistryDashboardProps {
  registryData: RegistryDataItem[];
}

const RegistryDashboard: React.FC<RegistryDashboardProps> = ({ registryData }) => {
  const { isModalOpen, openModal, closeModal } = useModalState();

  return (
    <div className="CardRegistryDashWrapper">
      {registryData.map((registry: RegistryDataItem) => (
        <React.Fragment key={registry.type}>
          <DashboardCard
            registry={registry}
            onMoreInfo={() => openModal(registry.type)}
          />

          <RegistryDashModal
            isShown={isModalOpen(registry.type)}
            onHide={() => closeModal(registry.type)}
            iconName={registry.iconName}
            title={registry.title}
            description={registry.modalDescription}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default RegistryDashboard;
